import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';

export const ActivityButton = styled.button`
	background: transparent;
	border: 0;
	padding: 0;
	margin: 0;
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	cursor: pointer;
	color: inherit;
	font: inherit;

	&:focus-visible {
		outline: 2px solid #257226;
		outline-offset: 6px;
		border-radius: 12px;
	}
`;

export const ActivityContainer = styled.div`
	text-align: center;
	padding: 0.75rem;
	width: 7rem;
	aspect-ratio: 1/1;
	background-color: #257226;//var(--ion-color-secondary);
	border-radius: 50%;
	color: #fff;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);
	svg {
		width: 3.75rem;
		height: 3.75rem;
		max-width: 100%;
		max-height: 100%;
		overflow: visible;
		flex-shrink: 0;
	}
`;

export const ActivitesContainer = styled.section`
	padding: 2rem 0;
	margin: 1.5rem 0;
	background-color: #e0ec89; //var(--bg-200);
	box-shadow: inset 0 0 8px rgba(0, 0, 0, 0.05);
	h2 {
		text-align: center;
		margin-bottom: 2rem;
	}
	& + section {
		header {
			border-top: none;
		}
	}
	ion-icon {
		font-size: 24px;
		margin-bottom: 5px;
		fill: #fff;
	}
`;

export const ActivitySwiper = styled(Swiper)`
	width: 100%;
	height: 100%;
	padding: 0 1.5rem !important;
	overflow: visible !important;
`;

export const ActivitySwiperSlide = styled(SwiperSlide)`
	max-width: 7rem;

	p {
		font-size: 0.875rem;
		color: #257226;//var(--ion-color-primary);
		margin: 0.5rem 0;
		text-align: center;
	}
`;
